import React, {Fragment, useState} from 'react';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {Snackbar} from '../../../Snackbar';
import {StyledCardCodeField, StyledCardCodeValue, StyledCopyButton} from './styles';
import {SaludiaCardCodeProps} from './types';

const {copyNumber} = translations['pt-br'].privateFlow.healthCard;
const {copyCardNumberAria} = translations['pt-br'].privateFlow.services.saludia;

export function SaludiaCardCode({value}: SaludiaCardCodeProps) {
	const [showSnackbar, setShowSnackbar] = useState(false);

	const handleCopy = async () => {
		if (!value) return;
		await navigator.clipboard.writeText(value);
		setShowSnackbar(true);
	};

	if (!value) return null;

	return (
		<Fragment>
			<StyledCardCodeField data-testid="saludia-card-code">
				<StyledCardCodeValue>{value}</StyledCardCodeValue>
				<StyledCopyButton type="button" aria-label={copyCardNumberAria} onClick={handleCopy}>
					<Icon name="content-copy-filled" size={20} />
				</StyledCopyButton>
			</StyledCardCodeField>
			<Snackbar
				open={showSnackbar}
				message={copyNumber}
				onClose={() => setShowSnackbar(false)}
				autoHideDuration={600}
			/>
		</Fragment>
	);
}
